import { AxiosError } from 'axios';
import { Namespace, TFunction } from 'react-i18next';

import { ErrorCode, IError, IErrorResponse } from '@app/models/error';

export const getResponseErrors = (err: unknown): IError[] =>
  (err as AxiosError<IErrorResponse>)?.response?.data?.errors || [];

export const getResponseStatus = (err: unknown): number | undefined => (err as AxiosError)?.response?.status;

export const isForbiddenError = (err: unknown): boolean => getResponseStatus(err) === 403;

export const hasErrorCode = (err: unknown, codes: string[]): boolean =>
  getResponseErrors(err).some((error) => codes.includes(error.code));

const UNFINISHED_ORDERS_CODES: string[] = [
  ErrorCode.PARTICIPATION_HAS_UNFINISHED_ORDERS,
  ErrorCode.WAREHOUSE_HAS_UNFINISHED_ORDERS,
];

export const getUnfinishedOrdersError = (err: unknown): IError | undefined =>
  getResponseErrors(err).find((error) => UNFINISHED_ORDERS_CODES.includes(error.code) && !!error.meta?.orders?.length);

export const translateApiError = (error: IError, t: TFunction<Namespace<'validation'>>): string =>
  (error.code ? t(error.code, { defaultValue: error.title || error.code }) : error.detail || error.title) || '';
